import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approvedmovementrequest',
  templateUrl: './approvedmovementrequest.component.html',
  styleUrls: ['./approvedmovementrequest.component.css']
})
export class ApprovedmovementrequestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
